import { connectHits } from 'instantsearch.js/es/connectors'


function getSiteUrl()
{
  let siteUrl = $('.contenuPage').data('site-url');

  if(siteUrl.length === 0 ) return null;

  return siteUrl;
}

function getProduitUrl(slug)
{
  let siteUrl = getSiteUrl();

  if(siteUrl === null) {
    return null;
  }

  if(siteUrl.endsWith('/') === true) {
    return siteUrl + slug;
  }

  return siteUrl + '/' + slug;
}

function getEncart()
{
   return `<li>Il n’y a aucun résultat pour votre recherche</li>`;
}

const renderHits = (renderOptions, isFirstRender) => {
    const { hits, widgetParams, results } = renderOptions;

    widgetParams.container.innerHTML = `
      <ul class="tematik_listingAlgolia-liste">
        ${hits
          .map(
            item =>
              `<li>
                <a class="tematik_listingAlgolia-item" href="${getProduitUrl(item.nom_slug)}.html">
                  <figure class="tematik_listingAlgolia-image">
                      <img src="${item.illustration}" alt="${item.nom} illustration">
                  </figure>
                  <article class="tematik_listingAlgolia-contenu">
                        <h2 class="titre4 lettre-rouge">${item.nom}</h2>
                        ${item.description ? `<p>${item.description}</p>` : ''}
                  </article>
                </a>
              </li>`
          )
          .join('')}
          ${(results !== undefined && results.nbHits === 0) ? // encart afficher à la dernière page
            getEncart() : ''
          }
      </ul>
    `;

  };
  



const customHits = connectHits(renderHits);

export default customHits;